/**
 * Режим полноэкранного оверлея при старте: полный чеклист, только обновление SW, или короткий запуск после reload.
 */

export type BootOverlayMode = "full" | "sw-update-only" | "post-sw-restart";

const listeners = new Set<() => void>();

let mode: BootOverlayMode = "full";

export function getBootOverlayModeSnapshot(): BootOverlayMode {
  return mode;
}

export function subscribeBootOverlayMode(onStoreChange: () => void): () => void {
  listeners.add(onStoreChange);
  return () => {
    listeners.delete(onStoreChange);
  };
}

export function setBootOverlayMode(next: BootOverlayMode): void {
  if (mode === next) return;
  mode = next;
  for (const l of listeners) {
    l();
  }
}
